import React from 'react';
import { StorePanel } from 'features/store';
import { SearchPanel } from 'features/search';
import { AnnouncementsPanel } from 'features/announcement';
import { LastOrderPanel } from 'features/order';
import { CategoriesPanel } from 'entities/Menu/components/CategoriesPanel';

interface IProps {
  isSearchMode: boolean;
}

export const MainPanel: React.FC<IProps> = React.memo(({ isSearchMode }) => {
  return (
    <>
      <StorePanel />
      <SearchPanel />
      {/* Announcements sit directly under the search bar (Figma: Store → Search → Frame 2161). */}
      <AnnouncementsPanel />
      <LastOrderPanel />
      {!isSearchMode && <CategoriesPanel />}
    </>
  );
});
